import InfoIcon from '@mui/icons-material/Info'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatBigMoney, formatInteger } from '../../../packages/utils/numberFormatters'
import { DynamicIconButton } from '../../../utils/tooltip/DynamicIconButton'
import { FactsTable, FactsTableRow } from '../../components/FactsTable'
import { useLoaderData } from 'react-router'
import { translateMillistreamSector } from '../../../utils/millistreamSectors'

function CompanyAbout() {
    const company = useLoaderData()
    const { i18n, t } = useTranslation()
    const locale = i18n.language

    if (!company) return null

    const tableRows = []

    tableRows.push(
        <FactsTableRow key={tableRows.length} label={t('entities.company.fields.name')}>
            {company.name}
        </FactsTableRow>,
    )

    tableRows.push(
        <FactsTableRow key={tableRows.length} label={t('pages.companies.orgNumber')}>
            {company.registrationNumber}
        </FactsTableRow>,
    )

    tableRows.push(
        <FactsTableRow key={tableRows.length} label={t('entities.company.fields.industry')}>
            {translateMillistreamSector(1, company.sector1)} <br />
            {translateMillistreamSector(2, company.sector2)} <br />
            {translateMillistreamSector(3, company.sector3)}
        </FactsTableRow>,
    )

    tableRows.push(
        <FactsTableRow
            key={tableRows.length}
            label={t('pages.companies.totalShares')}
            IconComponent={
                <DynamicIconButton
                    title={t('pages.companies.tooltips.totalShares')}
                    IconComponent={InfoIcon}
                    placement='top'
                    padding='0px 4px'
                />
            }
        >
            {formatInteger(company.millistreamTotalshares, { locale })}
        </FactsTableRow>,
    )

    tableRows.push(
        <FactsTableRow
            key={tableRows.length}
            label={t('pages.companies.marketCap')}
            IconComponent={
                <DynamicIconButton
                    title={t('pages.companies.tooltips.marketCap')}
                    IconComponent={InfoIcon}
                    placement='top'
                    padding='0px 4px'
                />
            }
        >
            {company.marketcap
                ? formatBigMoney(company.marketcap, {
                      locale,
                      currencySymbol: company.currency,
                  })
                : '-'}
        </FactsTableRow>,
    )

    return <FactsTable rows={tableRows} />
}

export default CompanyAbout
